/**
 * Typed tenant location telemetry API facade over the generated contract client.
 */

import { locationTelemetryApi } from '../api/generated/locationTelemetry.api.js';
import {
  type SiteTelemetrySettingsResponse,
} from '@cnapse/shared/schemas.js';
import type { LocationTagGeofencingResponse } from '@cnapse/shared/location-tag-registry.schema.js';

class LocationTelemetryService {
  async getSiteTelemetrySettings(siteId: string): Promise<SiteTelemetrySettingsResponse> {
    return locationTelemetryApi.getSiteTelemetrySettings({ siteId }) as Promise<SiteTelemetrySettingsResponse>;
  }

  async putSiteTelemetrySettings(
    siteId: string,
    cloudZoneAlarmsEnabled: boolean,
  ): Promise<SiteTelemetrySettingsResponse> {
    return locationTelemetryApi.putSiteTelemetrySettings(
      { siteId },
      { cloudZoneAlarmsEnabled },
    ) as Promise<SiteTelemetrySettingsResponse>;
  }

  async patchTenantLocationTagGeofencing(
    siteId: string,
    tagId: string,
    geofencingEnabled: boolean,
  ): Promise<LocationTagGeofencingResponse> {
    return locationTelemetryApi.patchTagGeofencingBySite(
      { siteId, tagId },
      { geofencingEnabled },
    ) as Promise<LocationTagGeofencingResponse>;
  }

  async getTenantLocationTagGeofencing(tagId: string): Promise<LocationTagGeofencingResponse> {
    return locationTelemetryApi.getTagGeofencingByTag({ tagId }) as Promise<LocationTagGeofencingResponse>;
  }

  async patchTenantLocationTagGeofencingByTagId(
    tagId: string,
    geofencingEnabled: boolean,
  ): Promise<LocationTagGeofencingResponse> {
    return locationTelemetryApi.patchTagGeofencingByTag(
      { tagId },
      { geofencingEnabled },
    ) as Promise<LocationTagGeofencingResponse>;
  }
}

export const locationTelemetryService = new LocationTelemetryService();
